import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { FC } from "react";
export interface ProgressStepperProps {
  steps: number;
  currentStep?: number | null;
  initialPercentage?: number;
  className?: string;
  inverted?: boolean;
}
const ProgressStepper: FC<ProgressStepperProps> = t0 => {
  const $ = _c(19);
  const {
    steps,
    initialPercentage,
    currentStep,
    className,
    inverted
  } = t0;
  const isIndeterminate = currentStep === undefined || currentStep === null;
  const resolvedSteps = steps ?? (isIndeterminate ? 1 : currentStep + 1);
  const percentage = isIndeterminate ? 0 : 100 / resolvedSteps * (currentStep ?? 0);
  let progressStyle;
  if ($[0] !== initialPercentage || $[1] !== isIndeterminate || $[2] !== percentage) {
    progressStyle = {};
    if (!isIndeterminate) {
      progressStyle.width = `${percentage}%`;
      if (initialPercentage || initialPercentage === 0) {
        progressStyle.minWidth = `${initialPercentage}%`;
      }
    }
    $[0] = initialPercentage;
    $[1] = isIndeterminate;
    $[2] = percentage;
    $[3] = progressStyle;
  } else {
    progressStyle = $[3];
  }
  const t1 = !inverted;
  let t2;
  if ($[4] !== className || $[5] !== inverted || $[6] !== t1) {
    t2 = clsx("rounded-xs overflow-hidden", className, {
      "bg-neutral-0/30": inverted,
      "bg-neutral-25": t1
    });
    $[4] = className;
    $[5] = inverted;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = !inverted;
  const t4 = !isIndeterminate;
  let t5;
  if ($[8] !== inverted || $[9] !== isIndeterminate || $[10] !== t3 || $[11] !== t4) {
    t5 = clsx("h-[6px] rounded-xs", {
      "bg-primary-800": t3,
      "bg-primary-100": inverted,
      "duration-500 min-w-[5%] max-w-full transition-all": t4,
      "w-1/3 animate-progress-indeterminate": isIndeterminate
    });
    $[8] = inverted;
    $[9] = isIndeterminate;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== progressStyle || $[14] !== t5) {
    t6 = <div className={t5} data-testid="progress-bar" style={progressStyle} />;
    $[13] = progressStyle;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <div className={t2}>{t6}</div>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default ProgressStepper;